/**
 * Referral promotions campaign — single place for paths and the removal tag.
 *
 * When deleting this feature, search the repo for `REFERRAL_PROMOTIONS` and follow
 * `REMOVAL.md` in this folder.
 */
export const REFERRAL_PROMOTIONS_FEATURE_TAG = 'REFERRAL_PROMOTIONS';

export const REFERRAL_PROMOTIONS_PAGE_PATH = '/something-new-is-coming';

export const REFERRAL_PROMOTIONS_CMS_PATH = 'referral-revamb-promotion';

export const REFERRAL_PROMOTIONS_STATIC_IMAGES = 'referral-promotions';
